import { Component, OnInit, Input, SimpleChanges, EventEmitter, Output } from '@angular/core';
import { switchMap } from 'rxjs/operators';
import { HelpersService } from '../../../services/tools/helpers.service';
import { PromotoresService } from '../../../services/promotores.service';
import { CreditosService } from '../../../services/creditos.service';

@Component({
  selector: 'app-formulario-promotor',
  templateUrl: './formulario-promotor.component.html'
})
export class FormularioPromotorComponent implements OnInit {

    @Input() public idCreditos : number = null;
    @Input() public isEditable: boolean = false;
    //Cliente form
    private isInitialized : boolean = false;
    public isLoading: boolean = false;
    public errors : any = {};

    public promotores: any = [];
    public promotor: any = {};

    constructor(
      private helperService: HelpersService,
      private service: PromotoresService,
      private creditosService: CreditosService
    ){
    }

    ngOnInit() {
    }
    
    public loadComponent(){
        if(!this.isInitialized){
            this.getPromotores(this.idCreditos);
            this.isInitialized = true;
        }
    }

    private getPromotores(idCreditos: number){
        let credito = null;
        this.isLoading = true;
        //Primero se obtienen los datos del crédito, para saber si esté tiene asociado un promotor
        this.creditosService.get(idCreditos).pipe(
          switchMap(response => {
            credito = response.json().content; 

            return this.service.getAll({ order: 'nombre' })}
            )
        ).subscribe(
          promotoresResponse => {
            const jsonResult = promotoresResponse.json();
            
            this.promotores = promotoresResponse.json().content;

            //Seleccionamos el promotor en el combo
            if(credito && credito.promotor){
                this.promotor = credito.promotor; 
            }            
            
            this.isLoading = false;
          
        }, error =>
        {
            this.isLoading = false;
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);
          
            if(error.status == 400) {
                this.helperService.setBackendErrors(error.json().content, this.errors);
                this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
        });
    }

    public onSelectedPromotor(promotor: any){
        this.promotor = promotor;
    }

    public savePromotor(){
        let promotorId = this.promotor.id ? this.promotor.id : null;

        const data = {
          id: this.idCreditos,
          promotor: promotorId
        };
    
        this.creditosService.updatePromotor(data).subscribe(
          (response)=>
          {
            const content = response.json().content;
            this.helperService.notification('Promotor actualizado', 'Se ha actualizado exitosamente el promotor del crédito ', 'success');
          }, error =>
          {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);
    
            if(error.status === 400) {
              this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
          }
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/creditos/components/formulario-promotor/formulario-promotor.component.ts